import client from './client';

export const invitesApi = {
  send: (data) => client.post('/invites/send', data),
  validate: (token) => client.get(`/invites/validate/${token}`),
  complete: (data) => client.post('/invites/complete', data),
  getMyInvites: () => client.get('/invites/my-invites'),
};
